module.exports = __webpack_public_path__ + "img/icon-24-slate-ic-chev-e-copy.64c0acf5.svg";